export enum DailyNewsEventType {
  DAILY_NEWS_OUTCOME_EVENT = 'daily_news_outcome_event',
  DAILY_NEWS_REPORT_ACTIVITY_PROGRESS_EVENT = 'daily_news_report_activity_progress_event',
  DAILY_NEWS_CLOSE_EVENT = 'daily_news_close_event',
  DAILY_NEWS_HEIGHT_EVENT = 'daily_news_height_event',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/daily-news-events.enum.ts